import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { Bar } from "react-chartjs-2";

const AgeGroupChart = ({ overviewData }) => {
  const [labelProps, setLabelProps] = useState([]);
  const [date, setDate] = useState(moment().format("LLL"));
  const { age_group_distribution } = overviewData;

  const dateRef = useRef(null);
  useEffect(() => {
    const labels = age_group_distribution?.map((key) => key.age_group)
    setLabelProps(labels)
  }, [])
  useEffect(
    () => {
      dateRef.current = setInterval(
        () => setDate(moment().format("LLL")),
        60_000
      );
      return () => clearInterval(dateRef.current);
    }, // eslint-disable-next-line
    []
  );
  const dataState = {
    labels: labelProps,
    datasets: [
      {
        label: "Age Group Distribution",
        data: age_group_distribution?.map((key) => key.y),
        borderWidth: 1,
        backgroundColor: "#0A74DC",
      },
    ],
  };
  return (
    <div className="overview-graph">
      <div className="overview-graph-header">
        <div className="overview-graph-header-left">
          <h4>Age Group Distribution</h4>
          <p>{date}</p>
        </div>
      </div>
      <div className="overview-graph-section">
        <Bar
          data={dataState}
          options={{
            scales: {
              y: {
                beginAtZero: true,
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default AgeGroupChart;
